import { useSyncExternalStore } from 'react';

const BELOW_MD = '(max-width: 767.98px)';

const subscribe = (onChange: () => void) => {
    const query = window.matchMedia(BELOW_MD);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
};

/**
 * SSR-safe md-breakpoint check (false on the server — desktop assumption).
 *
 * Hydration reads the server's answer and corrects straight after. A component
 * that first mounts on the client reads the viewport on its first render, so
 * anything it fetches on that render is already for the right breakpoint.
 */
export const useIsBelowMd = (): boolean =>
    useSyncExternalStore(
        subscribe,
        () => window.matchMedia(BELOW_MD).matches,
        () => false,
    );
